import type { RenderContext, VideoFrame } from '../../types';
import { BaseEffect } from '../base';
import { stableEffectSeed, withFullFrame } from './composite';
import { buildLensDrops, drawLensDrops } from '../../particles/engine';

const DEFAULTS = { count: 20, size: 0.5, refraction: 0.8 };

export class LensDropsEffect extends BaseEffect {
  constructor(id: string, clip: Partial<import('../../types').EffectTimelineClip>) {
    super(id, 'lens_drops', clip, DEFAULTS);
  }

  protected renderGpu(frame: VideoFrame, params: Record<string, number>, context: RenderContext): VideoFrame {
    return this.renderCpu(frame, params, context);
  }

  protected renderCpu(frame: VideoFrame, params: Record<string, number>, context: RenderContext): VideoFrame {
    const seed = stableEffectSeed(context, this.id);
    const drops = buildLensDrops(
      frame.width, frame.height, params.count, params.size, params.refraction,
      context.frameIndex, seed,
    );
    return withFullFrame(frame, (ctx, w, h, src) => {
      drawLensDrops(ctx, src, drops, w, h);
    });
  }
}
